/** 取签名 URL 后以 Blob 触发下载；跨域链接的 download 属性不生效，必须走 Blob。 */
export async function downloadUrl(url: string, filename?: string): Promise<void> {
  if (!url) throw new Error('文件地址为空')
  const response = await fetch(url)
  if (!response.ok) throw new Error(`下载失败：${response.status}`)
  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = filename || url.split('/').pop() || 'download'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(objectUrl)
}
